function isRangeInsideHiddenMods(range: Range): boolean {
  const container = range.commonAncestorContainer;
  const element = container instanceof Element ? container : container.parentElement;
  return !!element?.closest('.lex-hide-mods');
}

function getDivOfSelection() {
  const selection = document.getSelection();
  if (!selection) return '';
  if (selection.rangeCount === 0) return '';
  if (selection.toString().trim() === '') return '';
  const range = selection.getRangeAt(0);
  if (range.collapsed) return '';
  const div = document.createElement('div');
  if (isRangeInsideHiddenMods(range)) div.className = 'lex-hide-mods';
  div.appendChild(range.cloneContents());
  return div;
}

export const printDiv = (divId: string): void => {
  const element: HTMLElement | null = document.getElementById(divId);
  if (!element) {
    console.error(`Element with id "${divId}" not found.`);
    return;
  }
  const printContents = element.cloneNode(true);
  const popupWin: Window | null = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

  if (!popupWin) {
    console.error(`Cannot open popup window`);
    return;
  }

  popupWin.document.open();
  popupWin.document.write(`
    <!DOCTYPE html>
      <html>
        <head>
          <style>
            ${printCss}
          </style>
        </head>
        <body>
          <div id='root'></div>
        </body>
      </html>
    `);
  const mainPrintElement = popupWin.document.getElementById('root');
  if (!mainPrintElement) {
    console.error(`Cannot find root element`); // should never happen
    popupWin.close();
    return;
  }
  mainPrintElement.appendChild(printContents);
  popupWin.document.close();
  popupWin.focus();
  popupWin.print();
  popupWin.close();
};

export const printSelection = (): boolean => {

  const selection = getDivOfSelection();
  if (!selection) return false;
  const printContents = selection.cloneNode(true);
  const popupWin: Window | null = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

  if (!popupWin) {
    console.error(`Cannot open popup window`);
    return false;
  }

  popupWin.document.open();
  popupWin.document.write(`
    <!DOCTYPE html>
      <html>
        <head>
          <style>
            ${printCss}
            .lex-highlight {
              font-weight: bold;
              background-color: #ffed77;
              color: #333;
              display: inline-block;
            }
          </style>
        </head>
        <body>
          <div id='root'></div>
        </body>
      </html>
    `);
  const mainPrintElement = popupWin.document.getElementById('root');
  if (!mainPrintElement) {
    console.error(`Cannot find root element`); // should never happen
    popupWin.close();
    return false;
  }
  mainPrintElement.appendChild(printContents);
  popupWin.document.close();
  popupWin.focus();
  popupWin.print();
  popupWin.close();
  return true;
};


const printCss = `
@media print {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    page-break-after: avoid;
    page-break-inside: avoid;
  }
  img {
    page-break-inside: avoid;
    page-break-after: avoid;
  }
  blockquote,
  table,
  pre {
    page-break-inside: avoid;
  }
  ul,
  ol,
  dl {
    page-break-before: avoid;
  }
  #docviewer-wrap {
    top: 0 !important;
  }
  div {
    display: block !important;
  }
  .hide4print,
  .side-panel-wrap,
  .modal {
    display: none !important;
  }

  @page {
    size: auto; /* auto is the initial value */

    /* this affects the margin in the printer settings */
    /* margin: 25mm 25mm 25mm 25mm; */
  }
  body {
    margin: 0px !important;
  }
}

.lex-hide-mods .lex-taiat,
.lex-hide-mods .lex-taiat-block {
  display: none !important;
}
  `
